module.exports = __webpack_public_path__ + "static/anne-pitman-rolling-e358581a275ac8a4dc6f36217feac90d.jpg";